module.exports = __webpack_public_path__ + "img/advantage4.f6ad61e8.svg";